/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherMoonIcon16Solid = forwardRef('WeatherMoonIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.933 2.765A1.02 1.02 0 0 0 6.805 1.7a.98.98 0 0 0-1.091-.319 7 7 0 1 0 8.904 8.904.979.979 0 0 0-.319-1.091 1.02 1.02 0 0 0-1.064-.128 4.75 4.75 0 0 1-6.302-6.302Z" })));
});
